import type { AccentColor } from "../hooks/use-accent";
import { useAccent } from "../hooks/use-accent";

const ACCENTS: readonly AccentColor[] = [
  "amber",
  "blue",
  "green",
  "purple",
  "rose",
  "teal",
];

const ACCENT_DISPLAY_COLORS: Record<AccentColor, string> = {
  amber: "#d97706",
  blue: "#2563eb",
  green: "#16a34a",
  purple: "#9333ea",
  rose: "#e11d48",
  teal: "#0d9488",
};

export function AccentPicker() {
  const { accent, setAccent } = useAccent();

  return (
    <div className="flex gap-1.5 items-center">
      {ACCENTS.map((color) => (
        <button
          key={color}
          type="button"
          onClick={() => setAccent(color)}
          className={`w-6 h-6 rounded-full transition-all ${
            accent === color
              ? "ring-2 ring-offset-2 ring-offset-surface dark:ring-offset-surface-alt"
              : ""
          }`}
          style={{ backgroundColor: ACCENT_DISPLAY_COLORS[color] }}
          aria-label={color}
          title={color}
        />
      ))}
    </div>
  );
}
